import '@shared/app.css';
import '@shared/lib/api-fetch';
